import { Grid } from "antd";

import { Text } from "@/components/Typography";
import { useGetInstallationList, useInstallationSelectStore } from "@/layout/MainLayout";

const { useBreakpoint } = Grid;

function InstallationItemBreadcrumb() {
  const installationRef = useInstallationSelectStore(
    state => state.installationRef,
  );
  const { data: installationList } = useGetInstallationList();
  const { xs } = useBreakpoint();

  const installationItem = installationList?.results.find(item =>
    item.ref === installationRef);

  return (
    <Text
      ellipsis
      style={{
        width: xs ? "150px" : undefined,
      }}
    >
      {installationItem?.label}
    </Text>
  );
}

export default InstallationItemBreadcrumb;
